import { Organization } from '@oolio-group/domain';
import React, { useMemo, useState } from 'react';
import {
  ActivityIndicator,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import Search from '../../component/System/Search/Search';
import { styles } from './PairingScreen.styles';
import theme from '../../common/theme';
import Icon from '../../component/Icon/Icon';

interface OrganizationListProps {
  onSelect?: (org: Pick<Organization, 'id' | 'name'>) => void;
  onSearch?: (searchString: string) => void;
  organizations: Pick<Organization, 'id' | 'name'>[];
  loading?: boolean;
}

const OrganizationsList: React.FC<OrganizationListProps> = ({
  onSelect = () => undefined,
  organizations,
  loading = false,
}: OrganizationListProps) => {
  const [searchText, setSearchText] = useState('');

  const filteredOrgs = useMemo(() => {
    return organizations
      .filter(org => org.name.toLowerCase().includes(searchText.toLowerCase()))
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [searchText, organizations]);

  return (
    <View style={styles.content}>
      <Text style={styles.title}>Select organisation to continue...</Text>
      <Search
        testID="search"
        maxLength={50}
        onChangeText={setSearchText}
        placeholder="Search organisations by name..."
        containerStyle={styles.search}
      />
      {loading ? (
        <View style={styles.loading}>
          <ActivityIndicator size={20} color={theme.palette.primary} />
        </View>
      ) : (
        <View style={styles.table}>
          <ScrollView contentContainerStyle={styles.scrollList}>
            {filteredOrgs.length > 0 ? (
              filteredOrgs.map(org => (
                <TouchableOpacity
                  key={org.id}
                  style={styles.rowOrg}
                  onPress={() => onSelect(org)}
                >
                  <Text style={styles.textParent}>{org.name}</Text>
                  <Icon name="angle-right" color={theme.palette.mono500} />
                </TouchableOpacity>
              ))
            ) : (
              <View style={styles.loading}>
                <Text style={styles.emptyText}>No organisations found.</Text>
              </View>
            )}
          </ScrollView>
        </View>
      )}
    </View>
  );
};

export default OrganizationsList;
